var lib_core = require("lib-core");
var showUI;
if(showUI = (typeof window !== 'undefined'))
    var ui_extensions = require("ui-extensions");

var DeleteStateMachine = require("./deleteStateMachine.js");

var DeleteController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        REMOVE_BUTTON: {id: 'abs_21', name: "REMOVE_BUTTON", isGuiButton: true }
    });
};

lib_core.inherit(DeleteController, lib_core.Controller);
if(showUI) {
    DeleteController.inject = {
        tabController : ui_extensions.TabController
    };
} else {
    DeleteController.inject = {};
}
module.exports = DeleteController;

DeleteController.prototype.beforeLoad = function() {
    lib_core.Controller.prototype.beforeLoad.call(this);

    this.tabController.getView().registerButton({
        name: 'Delete',
        title: 'Delete (Delete)',
        sortOrder: 100,
        eventType: lib_core.GuiEvents.REMOVE_BUTTON,
        style: {
            icon: 'icon-trash.svg'
        },
        group: "modifier"
    });
};

DeleteController.prototype.createStateMachine = function () {
    return new DeleteStateMachine(this.root, this.getModel());
};
